import React from 'react';
import './App.css';
import ProvisionForm from "./ProvisionForm";

function App() {
  return (
    <div className="App">
        <ProvisionForm/>
    </div>
  );
}

export default App;
